import { useEffect, useRef } from "react";

function Welcome () {

    const headerRef1 = useRef<HTMLHeadingElement>(null); // Ref for the first header (h2)
    const headerRef2 = useRef<HTMLHeadingElement>(null); // Ref for the second header (h3)
    const lastKnownScrollPosition = useRef(0); // Ref to store the scroll position
    const ticking = useRef(false); // Ref to track whether a frame is requested

    // Function to shift the header positions based on scroll
    const shiftWelcomeHeaders = (scrollPos: number) => {
        if (headerRef1.current) {
            headerRef1.current.style.top = `${scrollPos * -0.3}px`; // Example scroll effect
        }
        if (headerRef2.current) {
            headerRef2.current.style.top = `${scrollPos * -0.3}px`; // Example scroll effect
        }
    };

    useEffect(() => {
        // Scroll event listener
        const handleScroll = () => {
            lastKnownScrollPosition.current = window.scrollY;

            if (!ticking.current) {
                window.requestAnimationFrame(() => {
                    shiftWelcomeHeaders(lastKnownScrollPosition.current); // Adjust headers based on scroll
                    ticking.current = false; // Reset ticking after handling scroll
                });

                ticking.current = true;
            }
        };

        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);

        // Cleanup scroll event listener when the component unmounts
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []); // Empty dependency array ensures this runs once after initial render


    // beekeeper canvas setup
    useEffect(() => {
        const canvas = document.getElementById('beekeeper') as HTMLCanvasElement;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const img = new Image();
        img.src = '/pictures/assets/ideomframsida.webp'; // Make sure this path is correct

        img.onload = () => {
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        };
        }, []);

    return (
        <section id="welcome" className="w-full">
            <div className="row">
                <div id="welcome-graphics-container">
                    <div id="welcome-graphics">
                    <canvas id="beekeeper" width="800" height="1280" style={{ display: 'block' }}></canvas>
                    </div>
                </div>
                <h2 className="welcomeheader" ref={headerRef1} style={{ top: '0px' }}>
                    Omsorsgsfull honung med familjär känsla
                </h2>
                <h3 className="welcomeheader" ref={headerRef2} style={{ top: '0px' }}>
                    Cerón's Honung är biodling med omtanke till binas välmående.
                </h3>
            </div>
        </section>
    );
}

export default Welcome;